import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--up-right",
  "use": "icon-arrow--up-right-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"icon-arrow--up-right\"><path d=\"M0 10.005.995 11l9.952-9.952-.995-.995L0 10.005Z\" fill=\"currentColor\" /><path d=\"M9.593 0v10.556H11V0H9.593Z\" fill=\"currentColor\" /><path d=\"M.445 0v1.407H11V0H.445Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol